export default "__VITE_ASSET__nRt54t8I__"